import { Link, useParams } from "react-router-dom";
import CustomPagination from "../CustomPagination";
import RowLoader from "../UI/RowLoader";
import { useEffect, useState } from "react";
import { getCourseLessons } from "../../apis";
import Tabs from "../Tabs";
import NewBadgeComponent from "../../assets/lottie/NewBadgeAnimation/NewBadgeComponent";

const liveLessonsPerPage = 5;
const recordedLessonsPerPage = 5;

const LessonsInCourseForClient = ({ id }) => {
  const { lessonId } = useParams();
  const [currentTab, setCurrentTab] = useState("live");

  const [liveLessonsCurPage, setLiveLessonsCurPage] = useState(1);
  const [recordedLessonsCurPage, setRecordedLessonsCurPage] = useState(1);
  const [sessionsNumbers, setSessionsNumbers] = useState({});

  const [sessionsData, setSessionsData] = useState({});
  const [paginator, setPaginator] = useState({});

  const [loadingGetLessons, setLoadingGetLessons] = useState(true);

  const LESSONS_TABS = [
    {
      key: "live",
      label: "Live Sessions",
      number: sessionsNumbers?.liveLessons,
    },
    {
      key: "recorded",
      label: "Recorded Sessions",
      number: sessionsNumbers?.recordedLessons,
    },
  ];
  const handleTabClick = (key) => {
    setCurrentTab(key);
    setLiveLessonsCurPage(1); // Reset to first page on tab change
    setRecordedLessonsCurPage(1);
  };

  const handlePageChange = (page) => {
    currentTab === "live"
      ? setLiveLessonsCurPage(page)
      : setRecordedLessonsCurPage(page);
  };
  useEffect(() => {
    setLoadingGetLessons(true);
    getCourseLessons(
      id,
      liveLessonsPerPage,
      liveLessonsCurPage,
      recordedLessonsPerPage,
      recordedLessonsCurPage
    )
      .then((response) => {
        setSessionsNumbers({
          liveLessons: response.data.data.liveLessons?.total,
          recordedLessons: response.data.data.recordedLessons?.total,
        });
        setSessionsData({
          live: response.data.data.liveLessons?.data,
          recorded: response.data.data.recordedLessons?.data,
        });
        setPaginator({
          live: {
            current_page: response.data.data.liveLessons.current_page,
            last_page: response.data.data.liveLessons.last_page,
          },
          recorded: {
            current_page: response.data.data.recordedLessons.current_page,
            last_page: response.data.data.recordedLessons.last_page,
          },
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoadingGetLessons(false);
      });
  }, [id, liveLessonsCurPage, recordedLessonsCurPage]);

  return (
    <>
      <Tabs
        options={LESSONS_TABS}
        onTabClick={handleTabClick}
        currentTab={currentTab}
      />
      {loadingGetLessons ? (
        <p className="tw-mx-auto">
          <RowLoader />
        </p>
      ) : (
        <ul className="list-group list-group-fit">
          {sessionsData?.[currentTab]?.length > 0 ? (
            sessionsData?.[currentTab]?.map((v, vi) => (
              <li className="list-group-item !tw-py-0" key={vi}>
                <div className="media tw-flex tw-items-center tw-min-h-12">
                  <div className="media-left">
                    <div className="text-muted">{v?.num}.</div>
                  </div>
                  <div className="media-body">
                    {v.lessonId === +lessonId ? (
                      <p className="tw-text-primaryLight">
                        {v?.[`lessonNameEn`]}
                      </p>
                    ) : (
                      <Link to={`/partners/courses/${id}/${v?.lessonId}`}>
                        {v?.[`lessonNameEn`]}
                      </Link>
                    )}
                  </div>
                  {v?.isAddedNew && <NewBadgeComponent className={"tw-w-16"} />}
                  {v?.isCompleted && (
                    <i className="material-icons tw-text-green-400 !tw-text-[25px]">
                      check_circle
                    </i>
                  )}
                  <div className="media-right tw-flex tw-flex-col tw-items-center">
                    <small className="text-muted-light">
                      {v?.lessonDuration}
                    </small>
                    <small className="text-muted-light">{v?.createdAt}</small>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <p className="tw-text-center tw-py-4">No sessions available.</p>
          )}
        </ul>
      )}

      <div className="flex justify-center my-2">
        <CustomPagination
          totalPages={paginator?.[currentTab]?.last_page ?? 1}
          currentPage={paginator?.[currentTab]?.current_page ?? 1}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default LessonsInCourseForClient;
